<template>
  <div class="target-decomposition">
    <AppBar />
    <div class="page-content">
      <div class="page-canvas">
        <div class="page-background">
          <img :src="top.imgBack" alt="" />
        </div>
        <div class="por-container">
          <div class="solution-info">
            <div class="solution-info-title">{{ top.title }}</div>
            <div class="solution-info-content" v-html="top.content">
              <!-- 利用在线招聘流程，帮助企业实现智能、便捷的招聘模式，
              建立企业自己的人才储备机制 -->
            </div>
          </div>
        </div>
      </div>
      <div ref="nav" class="page-nav">
        <div ref="navTabs" class="page-tabs" :style="{width: navWidth+'%', height: navHeight+'px'}">
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="['page-nav-item', topNaviId === item.id ? 'top-nav-item' : '']"
            @click="goAnchor(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div>
        <div ref="pain-points" class="pain-points">
          <div class="title">绩效目标分解痛点</div>
          <div class="pain-points-list">
            <div
              v-for="(item, index) in painPointsList"
              :key="index"
              class="pain-points-list-item"
              :class="{ 'change-pain-points': painPointsIndex === index }"
              @mousemove="onmousemove(index)"
            >
              <div class="item-text-box">
                <div class="item-title">{{ index+1 }}.{{ item.title }}</div>
                <div v-show="painPointsIndex === index " class="item-describe">{{ item.describe }}</div>
              </div>
              <div class="pain-points-list-index">0{{ index+1 }}</div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="sense-of-worth" class="sense-of-worth">
          <div class="title">产品价值分析</div>
          <div class="product-value-content">
            <div class="product-value-content-center">
              <img :src="valueCenterImg" alt="" />
            </div>
            <div class="content-text-wrap">
              <div v-for="(item, index) in valueList" :key="index" class="analysis-content">
                <img
                  :src="item.icon"
                  alt=""
                  class="analysis-img"
                />
                <div class="analysis-text">
                  <div class="analysis-title">{{ item.title }}</div>
                  <div class="analysis-content-text">
                    {{ item.describe }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="solution" class="solution">
          <div class="title">绩效分解解决方案</div>
          <div v-if="solutionContentList.length != 0" class="solution-content">
            <div class="solution-content-tabinfo-wrap">
              <div
                v-for="(item, index) in solutionContentList"
                :key="index"
                class="solution-content__tabInfo"
                :class="{'chack-tabInfo': index === solutionIndex}"
              >
                <div class="solution-content__tabTitle" @mouseenter="onClick(index)">
                  {{ item.title }}
                </div>
                <div v-if="index < solutionContentList.length-1" class="line"></div>
              </div>
            </div>
            <div class="solution-content__tabText">
              <transition name="tabContentWrap">
                <div :key="solutionIndex" class="solution-content__tabWrap">
                  <div class="solution-content__tabDes">
                    {{ solutionContentList[solutionIndex].describe }}
                  </div>
                  <img :src="solutionContentList[solutionIndex].img" alt="" class="solution-content__tabImage" />
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail } from '@/api/content';

export default {
  name: 'TargetDecomposition',
  data () {
    return {
      top: {
        title: '',
        content: '',
        imgBack: require('@/assets/decomposition/canvas.gif'),
      },
      navWidth: 80,
      navHeight: 60,
      offsetTop: 0,
      scrollTop: 0,
      position: 0,
      topNaviId: null,
      navList: [
        {
          title: '企业痛点',
          id: 'pain-points',
        },
        {
          title: '产品价值观',
          id: 'sense-of-worth',
        },
        {
          title: '解决方案',
          id: 'solution',
        },
      ],
      painPointsList: [
        // {
        //   title: '目标不清晰，考核浮于表面',
        //   describe: '大多数企业采用主观评分模式考核，无法明确考核目标，不能有效激励，员工达成或超越目标',
        // },
        // {
        //   title: '无法有效与企业战略目标绑定',
        //   describe: '大多数产量信息是统计员通过手工登记，管理人员无法有效核验数据。',
        // },
        // {
        //   title: '缺乏沟通和反馈环节',
        //   describe: '大多数产量信息是统计员通过手工登记，管理人员无法有效核验数据。',
        // },
      ],
      painPointsIndex: 0,
      valueCenterImg: '',
      valueList: [
        // {
        //   icon: require('@/assets/decomposition/icon/analysis-content1.png'),
        //   title: '个人能力与目标',
        //   describe: '分解任务目标时建立沟通机制，充分考虑员工个人能力和环境因素，能更好的实现整个团队目标达成',
        // },
        // {
        //   icon: require('@/assets/decomposition/icon/analysis-content2.png'),
        //   title: '经营目标与团队目标',
        //   describe: '团队目标需要能够有效支撑企业经营目标的达成，通过逻辑关系和目标转换，实现与企业战略目标的绑定',
        // },
        // {
        //   icon: require('@/assets/decomposition/icon/analysis-content3.png'),
        //   title: '激励制度',
        //   describe: '根据任务的难易程度设置不同的激励制度，能够有效提高员工的积极性和团队的协同能力',
        // },
        // {
        //   icon: require('@/assets/decomposition/icon/analysis-content4.png'),
        //   title: '绩效跟踪',
        //   describe: '在绩效周期内对绩效目标达成情况进行实时跟踪，方便管理者根据实际情况及时进行目标调整',
        // },
      ],
      solutionContentList: [
        // {
        //   title: '协商式目标分解',
        //   describe: '上下级对总体目标的分解和层次目标的落实进行充分的商谈或讨论，意见一致更好的促进绩效达成。',
        //   img: require('@/assets/decomposition/solution1.png'),
        // },
        // {
        //   title: '有效支撑战略目标',
        //   describe: '目标分解的最终目的是支持企业战略目标实现，将团队目标与企业目标建立联系是绩效目标分解的最终意义。',
        //   img: require('@/assets/decomposition/solution2.png'),
        // },
        // {
        //   title: '绩效过程考核',
        //   describe: '只注重结果忽略过程是绩效活动中的一大漏洞，有效的过程监管能够帮助管理者更好的监控目标达成情况和及时调整绩效方案。',
        //   img: require('@/assets/decomposition/solution3.png'),
        // },
      ],
      solutionIndex: 0,
    };
  },
  watch: {
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue === window.scrollY) {
          for (var i = 0; i < this.navList.length; i++) {
            var elementTop = this.$refs[`${this.navList[i].id}`].offsetTop - this.scrollTop - 1;
            if (elementTop <= 70) {
              this.topNaviId = this.navList[i].id;
            }
          }
        }
      }, 20);
    },
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      const nav = this.$refs.nav;
      this.offsetTop = nav.offsetTop;
    });
    this.getPageColumn();
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var offsetHeight = this.$refs.navTabs.offsetHeight;
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var headerFixed = this.scrollTop > this.offsetTop - offsetHeight / 2 - 70;
      var scroll = this.scrollTop - this.position;
      this.position = this.scrollTop;
      if (this.scrollTop <= 400) {
        this.navHeight = 52;
        this.navWidth = 80;
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (this.scrollTop >= 400 && !headerFixed) {
        this.navHeight += 0.04 * scroll;
        this.navWidth += 0.12 * scroll;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (headerFixed) {
        this.navHeight = 60;
        this.navWidth = 100;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'fixed';
        this.$refs.nav.style.top = offsetHeight / 2 + 70 + 'px';
      }
    },
    goAnchor(i) {
      // var id = '#' + i.id;
      // document.querySelector(id).scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      // });
      window.scrollTo({
        top: this.$refs[`${i.id}`].offsetTop - 70,
        left: 0,
        behavior: 'smooth',
      });
    },

    // 获取页面栏目
    async getPageColumn() {
      const params = { parentId: '1607260823548551168', };
      getColumnChild(params).then(async (res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '企业痛点') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                var painPointsItem = {
                  title: rtsult.title,
                  describe: rtsult.description,
                };
                this.painPointsList.push(painPointsItem);
              }
            });
          } else if (result[i].name === '产品价值观') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            this.valueCenterImg = result[i].icon;
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var valueItem = {
                  title: rrsult.data[j].title,
                  icon: rrsult.data[j].icon,
                  describe: rrsult.data[j].description,
                };
                this.valueList.push(valueItem);
              }
            });
          } else if (result[i].name === '解决方案') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var solutionContentItem = {
                  title: rrsult.data[j].title,
                  img: rrsult.data[j].icon,
                  describe: rrsult.data[j].description,
                };
                this.solutionContentList.push(solutionContentItem);
              }
            });
          } else if (result[i].name === '顶部图') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var content = rrsult.elements.find(obj => obj.name === 'content').content;
              var contentdoc = new DOMParser().parseFromString(content, 'text/html');
              this.top.title = rrsult.elements.find(obj => obj.name === 'subtitle').content;
              this.top.content = contentdoc.documentElement.textContent.replace(/&nbsp;/g, ' ');
              // this.top = {
              //   imgBack: rrsult.icon,
              // };
            });
          }
        }
      });
    },

    onmousemove(i) {
      this.painPointsIndex = i;
    },
    onClick(i) {
      this.solutionIndex = i;
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less" scoped>
.target-decomposition{
    background-color: #fff;
  .page-content{
    width: 100%;
    // padding-top: 70px;
    .page-canvas{
      width: 100%;
      height: fit-content;
      min-width: var(--minwidth);
      position: relative;
      background-size: cover;
      overflow: hidden;
      .page-background{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
        }
      }
      .por-container {
        width: 70%;
        max-width: 1200px;
        margin: 0 auto;
        position: relative;
        .solution-info {
          width: 480px;
          height: 560px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          box-sizing: border-box;
          .solution-info-title {
            font-size: 46px;
            font-weight: bold;
            line-height: 55px;
            color: #fff;
            margin-bottom: 29px;
          }
          .solution-info-content {
            font-size: 20px;
            line-height: 32px;
            color: #fff;
            margin-bottom: 44px;
          }
          // .solution-btn {
          //   width: 142px;
          //   height: 48px;
          //   background-color: #1589fd;
          //   color: #fff;
          //   text-align: center;
          //   line-height: 48px;
          //   cursor: pointer;
          //   border-radius: 24px;
          // }
        }
      }
    }
    .page-nav{
      width: 100%;
      display: flex;
      position: relative;
      justify-content: center;
      z-index: 50;
      .page-tabs{
        margin: 0 auto;
        box-shadow: 0px 2px 8px 0px rgba(139, 139, 139, 0.18);
        border-radius: 2px;
        background-color: #fff;
        display: flex;
        position: absolute;
        top: -26px;
        .page-nav-item{
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #181818;
          font-size: 14px;
          cursor: pointer;
        }
        .page-nav-item:hover{
          color: #00b0dc;
        }
        .top-nav-item {
          color: #fff;
          background-color: #00b0dc;
        }
        .top-nav-item:hover {
          color: #fff;
        }
      }
    }
    .pain-points{
      width: 1200px;
      padding-top: 115px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .pain-points-list{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .pain-points-list-item{
          flex: 1;
          min-width: 228px;
          height: 210px;
          margin-left: 15px;
          padding: 25px 18px 30px 30px;
          position: relative;
          box-sizing: border-box;
          background-color: #fff;
          border-left: 5px solid #00b0dc;
          box-shadow: 0px 5px 24px 0px rgba(200, 200, 200, 0.2);
          transition: all 0.3s ease-in-out;
          .item-text-box{
            width: 160px;
            position: relative;
            z-index: 9;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-top: 20px;
            // transition: all 0.3s ease-in-out;
            overflow: hidden;
            .item-title{
              font-size: 18px;
              font-weight: 500;
              color: #1e2127;
              transition: all 0.3s ease-in-out;
            }
            .item-describe{
              width: 100%;
              margin-top: 17px;
              font-size: 16px;
              font-weight: 300;
              color: #15b9e2;
              transition: all 0.3s ease-in-out;
            }
          }
          .pain-points-list-index{
            z-index: 0;
            position: absolute;
            line-height: 1;
            top: 15px;
            right: 0;
            font-size: 150px;
            font-family: Roboto-Bold;
            color: #f4f6fe;
            transition: all 0.3s ease-in-out;
          }
        }
        .pain-points-list-item:first-child{
          margin-left: 0;
        }
        .change-pain-points{
          flex: 1.5;
          background-color: #00b0dc;
          padding-right: 210px;
          .item-text-box{
            width: 100%;
            .item-title{
              color: #fff;
            }
          }
          .pain-points-list-index{
            color: #00b0dc;
          }
        }
      }
    }
    .sense-of-worth {
      width: 1200px;
      margin: 0 auto;
      padding-top: 30px;
      .title {
        font-family: OPPOSans-M;
        font-size: 32px;
        color: #181818;
        text-align: center;
        margin-top: 90px;
        margin-bottom: 60px;
      }
      .product-value-content {
        display: flex;
        justify-content: center;
        padding-bottom: 100px;
        position: relative;
        .product-value-content-center {
          height: 426px;
          img {
            display: block;
            height: 100%;
            width: auto;
          }
        }
        .content-text-wrap {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: flex-start;
          .analysis-content {
            width: 50%;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            padding-top: 65px;
            .analysis-img {
              width: auto;
              height: 25px;
              margin-top: 8px;
            }
            .analysis-text {
              width: 275px;
              height: 124px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              margin-left: 15px;
              .analysis-title {
                font-family: FontquanXinYiGuanHeiTi-Regular;
                font-size: 28px;
                color: #181818;
                margin-bottom: 21px;
              }
              .analysis-content-text {
                font-size: 16px;
                color: #181818;
              }
            }
          }
          .analysis-content:nth-child(2n){
            justify-content: flex-end;
          }
        }
      }
    }
    .solution{
      width: 1166px;
      margin: 0 auto;
      padding-top: 90px;
      padding-bottom: 90px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      .title{
        font-size: 32px;
        color: #181818;
        margin-bottom: 70px;
      }
      .solution-content{
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .solution-content-tabinfo-wrap{
              width: 160px;
              padding: 20px 0;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: flex-start;
              box-sizing: border-box;
              .solution-content__tabInfo{
                display: flex;
                flex-direction: column;
                align-items: center;
                .solution-content__tabTitle{
                    font-size: 20px;
                    color: rgba(24, 24, 24, 0.5);
                    cursor: pointer;
                }
                .line{
                    margin-top: 8px;
                    margin-bottom: 8px;
                    width: 1px;
                    height: 101px;
                    border-left: 2px dashed #00b0dc;
                }
              }
              .chack-tabInfo{
                .solution-content__tabTitle{
                  color: rgba(24, 24, 24, 1);
                }
              }
          }
          .solution-content__tabText{
            width: 968px;
            height: 340px;
            background: url('@/assets/decomposition/tabInfo-back.png') no-repeat;
            background-size: cover;
            padding: 20px 48px 20px 43px;
            box-sizing: border-box;
            .solution-content__tabWrap{
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              .solution-content__tabDes{
                width: 380px;
                margin-top: 68px;
                font-size: 20px;
                color: #181818;
              }
              .solution-content__tabImage{
                width: 400px;
                height: auto;
              }
            }
            .tabContentWrap-enter-active{
              animation: bounce-in 0.5s;
            }
            .tabContentWrap-leave-active{
              animation: bounce-in 0s reverse;
            }
            @keyframes bounce-in {
              0% {
                opacity: 0;
              }
              100% {
                opacity: 1;
              }
            }
          }
      }
    }
  }
}
</style>
